import React, { Fragment } from 'react';

import PagesError505Content from '../../Components/PagesError505/PagesError505Content';
export default function PagesError505() {
  return (
    <Fragment>
      <PagesError505Content />
    </Fragment>
  );
}
